export const partnerIDs = {
    commerceBank: 428,
    life360: 539,
    fraudArmor: 464,
    nexshield: 540,
    dowc: 538,
    avast: 2611,
    cyberIdLock: 2635,
    avg: 2659,
    avgTest: 2662,
    towerFCU: 2657,
    bitdefenderId: 2569,
};

export const blacklistedPartnerListForNevigateYourDashboardVideo: number[] = [partnerIDs.life360, partnerIDs.fraudArmor, partnerIDs.nexshield];

export const idfPartnerIds: number[] = [partnerIDs.dowc, partnerIDs.life360];

export const isIDFPartnerUser = (partnerID: number): boolean => {
    return idfPartnerIds.includes(partnerID);
};

export const isCommerceBankPartner = (partnerID: number): boolean => {
    const COMMERCE_BANK_PARTNER_ID: number = partnerIDs.commerceBank;
    if (partnerID === COMMERCE_BANK_PARTNER_ID) {
        return true;
    }
    return false;
};

export const isAvastPartner = (partnerID: number): boolean => {
    const AVAST_PARTNER_ID: number = partnerIDs.avast;
    if (partnerID === AVAST_PARTNER_ID) {
        return true;
    }
    return false;
};

export const isCyberIdLockPartner = (partnerID: number): boolean => {
    const CYBER_ID_LOCK_PARTNER_ID: number = partnerIDs.cyberIdLock;
    if (partnerID === CYBER_ID_LOCK_PARTNER_ID) {
        return true;
    }
    return false;
};

export const isTowerFCUPartner = (partnerID: number): boolean => {
    const TOWER_FCU_PARTNER_ID: number = partnerIDs.towerFCU;
    if (partnerID === TOWER_FCU_PARTNER_ID) {
        return true;
    }
    return false;
};

export const isAVGPartner = (partnerID: number): boolean => {
    const AVG_PARTNER_ID: number = partnerIDs.avg;
    if (partnerID === AVG_PARTNER_ID) {
        return true;
    }
    return false;
};

export const isAVGTestPartner = (partnerID: number): boolean => {
    const AVG_TEST_PARTNER_ID: number = partnerIDs.avgTest;
    if (partnerID === AVG_TEST_PARTNER_ID) {
        return true;
    }
    return false;
};

export const isBitdefenderPartner = (partnerID: number): boolean => {
    const BIT_PARTNER_ID: number = partnerIDs.bitdefenderId;
    if (partnerID === BIT_PARTNER_ID) {
        return true;
    }
    return false;
};
